export function truncateWord(word: string, count: number) {
  if (word.length > count) {
    return `${word.substring(0, count)}...`;
  } else {
    return word;
  }
}

export function formatPrice(price: number, currencyCode: string = 'ARS', locale: string = 'es-AR') {
  const numberFormat = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: 'code',
    minimumFractionDigits: 2,
  });

  return numberFormat.format(price / 100);
}

export function formatFileSize(bytes: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let index = 0;

  while (bytes >= 1024 && index < units.length - 1) {
    bytes /= 1024;
    index++;
  }

  return `${bytes.toFixed(2)} ${units[index]}`;
}

export function formatNumber(
  number: number,
  {
    minimumFractionDigits = 0,
    maximumFractionDigits = 0,
    locale = 'es-AR' /*navigator.language*/,
  }: { minimumFractionDigits?: number; maximumFractionDigits?: number; locale?: string } = {},
): string {
  const numberFormat = new Intl.NumberFormat(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  // Format the number
  return numberFormat.format(number);
}

export function truncateText(text: string, count: number) {
  const words = text.split(/\s+/);
  return words.slice(0, count).join(' ') + (words.length > count ? ' ...' : '');
}

export function stripHtml(html: string) {
  return html.replace(/<[^>]*>?/g, '');
}
